var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChamberOverflowColdWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 202,
    height: 76,
    viewBox: "0 0 202 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.541,
    x2: 0.5,
    y2: 0.576,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fafa78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8cb36"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Overflow-Cold_Water",
    "data-name": "Overflow-Cold Water",
    transform: "translate(0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9821",
    "data-name": "Group 9821",
    transform: "translate(-0.005 6.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M13.439,75.341a3.016,3.016,0,0,1-3.11-2.9V21.208a1.5,1.5,0,0,0-.51-1.11L1.59,12.569A2.722,2.722,0,0,1,.84,9.52,3.069,3.069,0,0,1,3.76,7.6H198.215a3.059,3.059,0,0,1,2.92,1.92,2.722,2.722,0,0,1-.75,3.05L192.156,20.1a1.486,1.486,0,0,0-.51,1.11V72.441a3.01,3.01,0,0,1-3.11,2.9Z",
    transform: "translate(0.005 -6.96)",
    fill: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M9.929,20.118a1.486,1.486,0,0,1,.51,1.11V72.521a3.007,3.007,0,0,0,3.1,2.9H188.456a3.007,3.007,0,0,0,3.1-2.9V21.228a1.5,1.5,0,0,1,.51-1.11l8.219-7.529a2.739,2.739,0,0,0,.75-3.05,3.069,3.069,0,0,0-2.92-1.92h-6.779a7.269,7.269,0,0,0-.83.68s-6.769,5.849-12.679,0c-.25-.25-.5-.47-.75-.68h-9.489a7.438,7.438,0,0,0-.7.68s-6.43,6.2-12.679,0c-.25-.25-.5-.47-.74-.68H143.129a6.578,6.578,0,0,0-.72.68s-5.82,7.609-12.509.98a12.7,12.7,0,0,0-2.06-1.66h-8.529a10.61,10.61,0,0,0-1.93,1.48V9.05s-6.26,5.159-11.469,0a8.588,8.588,0,0,0-1.86-1.43h-6.51a9.1,9.1,0,0,0-2.06,1.43S88.713,14.9,82.8,9.05a11.285,11.285,0,0,0-1.76-1.43H73.585a8.481,8.481,0,0,0-1.73,1.43s-6.43,6.2-12.679,0a11.847,11.847,0,0,0-1.75-1.43H49.106a9.393,9.393,0,0,0-1.76,1.43s-5.82,7.609-12.509.98A10.565,10.565,0,0,0,31.3,7.62h-5.52a10.691,10.691,0,0,0-3.41,2.17c-1.89,1.19-6.57,3.41-10.609-.6a8.445,8.445,0,0,0-2.12-1.57H3.88c-.07,0-.14.01-.21.01A9.173,9.173,0,0,0,1.35,9.19s-.14.11-.36.28c-.01.03-.03.04-.04.07a2.722,2.722,0,0,0,.75,3.05Z",
    transform: "translate(0.005 -6.96)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    d: "M198.225,8.26a2.227,2.227,0,0,1,1.74,3.829l-8.229,7.529a2.151,2.151,0,0,0-.72,1.59V72.441a2.363,2.363,0,0,1-2.46,2.25H13.439a2.363,2.363,0,0,1-2.46-2.25V21.208a2.151,2.151,0,0,0-.72-1.59L2.03,12.089A2.225,2.225,0,0,1,3.77,8.26H198.225m0-1.3H3.76A3.72,3.72,0,0,0,.23,9.3a3.376,3.376,0,0,0,.92,3.77L9.379,20.6a.855.855,0,0,1,.3.62V72.451A3.664,3.664,0,0,0,13.439,76H188.556a3.664,3.664,0,0,0,3.76-3.55V21.208a.8.8,0,0,1,.3-.62l8.229-7.529a3.389,3.389,0,0,0,.92-3.77,3.744,3.744,0,0,0-3.54-2.33Z",
    transform: "translate(0.005 -6.96)",
    fill: "#808184"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9822",
    "data-name": "Group 9822",
    transform: "translate(141.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9825",
    "data-name": "Group 9825",
    transform: "translate(-565.7 -2408.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(566 2409)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 18.2,
    cy: 18.2,
    r: 18.2,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3502",
    "data-name": "Group 3502",
    transform: "translate(580.988 2414.888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9416",
    "data-name": "Group 9416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M-.969,1.025H5.1L3.62,16.192H.529Z",
    transform: "translate(0.969 -1.025)",
    fill: "#121417"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M3.033,0A3.033,3.033,0,1,1,0,3.033,3.033,3.033,0,0,1,3.033,0Z",
    transform: "translate(0 18.2)",
    fill: "#121417"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    d: "M160.459,37.015a18.508,18.508,0,0,1,0-37.015h0a18.508,18.508,0,0,1,0,37.015Zm0-36.365a17.858,17.858,0,1,0,17.849,17.858A17.874,17.874,0,0,0,160.459.65Z",
    transform: "translate(-141.96)",
    fill: "#808184"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChamberOverflowColdWater);
export default __webpack_public_path__ + "static/media/chamber_overflow_cold_water.e48cede4eb8447c2d1ac06f9de841a19.svg";
export { ForwardRef as ReactComponent };